<div class="input-group mr-2">
  <input class="form-control" [ngModel]="uitime" [disabled]="true" />
  <span class="input-group-text" [ngbPopover]="calendarContent" container="body" autoClose="outside">
    <i class="fn-global-calendar cursor-pointer"></i></span>
</div>

<ng-template #calendarContent>
  @if (showTimePickerToggle) {
  <div *ngIf="showTimePickerToggle">
    <button class="btn btn-block btn-outline-secondary width-100" type="button" (click)="toggleDateTimeState($event)">
      <i class="fn-global-calendar"></i>
    </button>
    <div class="mt-auto">
      <ngb-timepicker #tp name="timepicker" [ngModel]="datetime" (ngModelChange)="onTimeChange($event)"
        [seconds]="seconds" [hourStep]="hourStep" [minuteStep]="minuteStep" [secondStep]="secondStep"
        [disabled]="disabled">
      </ngb-timepicker>
    </div>
  </div>
  }@else {
  <div>
    <ngb-datepicker id="dp" #dp name="datepicker" [ngModel]="datetime" (ngModelChange)="onDateChange($event)"
      [dayTemplate]="dayTemplate"  [markDisabled]="isDisabledDate" [minDate]="minDisableDate"></ngb-datepicker>
    <ng-template #dayTemplate let-date let-focused="focused">
      <span [class.focused]="focused" [class.focused]="focused" [class]="getDateClass(date)"
        (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
        {{ date.day }}
      </span>
    </ng-template>
    <button class="btn btn-block btn-outline-secondary width-100" [disabled]="isDisabled" type="button"
      (click)="toggleDateTimeState($event)">
      <i class="fn-global-clock"></i>
    </button>
  </div>
  }
</ng-template>
